import { makeGetApiCall } from "../../shared/makeApiCall";

export const getFeatureFlags = async () => {
  let callResult = await makeGetApiCall("featureFlags");

  if (callResult.success) {
    return callResult.data;
  } else {
    if (callResult.errorStatus === 401) {
      return null;
    }
  }
};

export const setFeatureFlags = async () => {
  var featureFlags = await getFeatureFlags();
  if (featureFlags && Array.isArray(featureFlags)) {
    featureFlags.forEach((flag) => {
      localStorage.setItem(flag.name, flag.status);
    });
  }
};
